export const GET_TAGS="app/list/GET_TAGS";
export const GET_TAG="app/edit/GET_TAG";
export const POST_TAG="app/edit/POST_TAG";
export const WAS_EDIT="app/edit/WAS_EDIT_TAG";
export const CHANGE_STATUS_EDIT="app/edit/CHANGE_STATUS_EDIT";